import * as React from 'react'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {importReg} from '../../dispatchers/appConstrImportDispatcher'
import {
  IConstrConnectValidationData,
  IConstrConnectValidationSuccessData
} from '../../interfaces/reducers/IConstrImport'

interface OwnProps {
  connectValidationData: IConstrConnectValidationData
}

interface ParentProps {}

interface DispatchProps {
  importReg: typeof importReg
}

type Props = DispatchProps & ParentProps & OwnProps

const ConstrImportConnectValidationsC = (props: Props) => {
  const getSuccessData = (successData: IConstrConnectValidationSuccessData) => {
    return (
      <div className="import-params-success">
        <div>Успешно създадени връзки</div>
        <br></br>
        <div>{`Брой парцели с нови данни за застрояване: ${successData.NewMatrix}`}</div>
        <div>{`Брой парцели с променени данни за застрояване: ${successData.ModMatrix}`}</div>
        <br></br>
        <div>{`Брой парцели с нови застроителни линии: ${successData.NewSites}`}</div>
        <div>{`Брой парцели с променени застроителни линии: ${successData.ModSites}`}</div>
        <br></br>
        <div>{`Брой нови ограничителни линии: ${successData.NewBuildings}`}</div>
        <div>{`Брой премахнати ограничителни линии: ${successData.RemovedBuildings}`}</div>
        <a href={successData.SuccessDxf} target="_blank" rel="noreferrer">
          DXF файл с промените
        </a>

        <br></br>
      </div>
    )
  }
  const getValidationStatusUI = () => {
    if (props.connectValidationData.loading) {
      if (props.connectValidationData.successData) {
        return getSuccessData(props.connectValidationData.successData)
      }
      return <div className="import-loading">В процес на създаване на връзки...</div>
    } else {
      if (
        props.connectValidationData.errors &&
        props.connectValidationData.errors.messages &&
        props.connectValidationData.errors.messages.length > 0
      ) {
        const errors: JSX.Element[] = []
        props.connectValidationData.errors.messages.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return (
          <div className="import-params-errors">
            <div>Грешки при създаване на връзки:</div>
            {errors}
            {props.connectValidationData.errors.dxf ? (
              <a href={props.connectValidationData.errors.dxf} target="_blank" rel="noreferrer">
                DXF файл с грешни полигони
              </a>
            ) : null}
          </div>
        )
      } else if (props.connectValidationData.successData) {
        return getSuccessData(props.connectValidationData.successData)
      }
    }
  }
  if (!props.connectValidationData.exists) {
    return <div></div>
  }
  return <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>{getValidationStatusUI()}</div>
}

const mapStoreToProps = (store: IAppStore) => ({
  connectValidationData: store.constrImport.connectValidationData
})

export const ConstrImportConnectValidations = connect<OwnProps, DispatchProps, ParentProps>(mapStoreToProps, {
  importReg
})(ConstrImportConnectValidationsC)
